module.exports = __webpack_public_path__ + "img/card_1_ref_3.d8650fb1.jpg";